import { FunctionComponent, useRef } from 'react'
import { Box, Typography, ListItemIcon } from '@material-ui/core'
import { AnimatedAvatar } from '../member-profile/styled'
import { OnboardingQuestion, BackendUser } from 'common/types'
import styled from 'styled-components/macro'
//@ts-ignore
import { useTheme } from 'styled-components'
import { ReactComponent as ImageEditIcon } from 'icons/image-edit.svg'
import { ReactComponent as DeleteIcon } from 'icons/trash.svg'
import { ReactComponent as UploadIcon } from 'icons/upload-avatar.svg'
import { useScreenSizes } from 'hooks/use-screen-sizes/useScreenSizes'
import { accountSettingsStoreState } from 'models/account-settings/account-settings.store'
import { observer } from 'mobx-react'
import { useAddAvatar } from 'pages/profile/hooks/useAddAvatar'
import { CustomIconContextMenu } from 'components/core/actions-menu-noborder/CustomIconContextMenu'

const FileNameBox = styled(Box)`
  font-size: 1em;
  color: ${props => props.theme.colors.accent1};
  padding: 0.25em;
  text-align: center;

  max-width: 15em;
  word-wrap: break-word;
`

export const StyledImageEditIcon = styled(ImageEditIcon)`
  && {
    fill: red;
    width: 24px;
    height: 24px;
    cursor: pointer;
  }
`

const StyledImageEditBox = styled(Box)`
  && {
    width: 32px;
    height: 32px;
    padding: 10;
    background: ${props => props.theme.colors.bgPrimary};
    border-radius: 28px;
    justify-content: center;
    align-items: center;
    gap: 10;
    display: flex;
    z-index: 1;
    opacity: 5;
  }
`

const StyledListItemIcon = styled(ListItemIcon)`
  width: 17.92px;
  height: 17.92px;
  transform: translate(30%, -15%);
`

interface AddAvatarProps {
  user: BackendUser
  setNewProfileData: Function
}

const AddAvatar2: FunctionComponent<AddAvatarProps> = ({
  user,
  setNewProfileData
}) => {
  const theme = useTheme()
  const { isDevice } = useScreenSizes()
  const { handleImageUpload, handleRemoveImage, previewImage } = useAddAvatar(user, setNewProfileData)
  const hiddenFileInput = useRef(null)
  return (
    <Box>
      <Box display="flex" flexDirection="column" alignItems="center" justifyContent="flex-start">
        <Box padding="0em 1em 1em 1em">
          <Box
            style={{
              width: '104px',
              height: '104px',
              justifyContent: 'flex-start',
              alignItems: 'flex-start',
              display: 'inline-flex'
            }}
          >
            <Box style={{ justifyContent: 'flex-start', alignItems: 'flex-start', gap: 10, display: 'flex' }}>
              <Box style={{ width: '104px', height: '104px', position: 'relative' }}>
                <Box
                  style={{
                    width: '104px',
                    height: '104px',
                    left: 0,
                    top: 0,
                    position: 'absolute',
                    borderRadius: 9999
                  }}
                />
                <AnimatedAvatar
                  src={previewImage || user?.image}
                  alt="member with a profile"
                  style={{ width: '104px', height: '104px' }}
                />
              </Box>
            </Box>
            <Box position="relative" top={isDevice ? "8%" : "50%"} left="-45%">
              {!user?.image ? (
                <CustomIconContextMenu
                  title=""
                  icon={
                    <StyledImageEditBox>
                      <StyledImageEditIcon fontSize="1.5rem" />
                    </StyledImageEditBox>
                  }
                  menuWidth="30rem"
                  bgColor={theme.colors.bgPrimary}
                  anchorOriginHorizontal="right"
                >
                  <Box display="flex" justifyContent="space-between" onClick={() => hiddenFileInput.current.click()}>
                    <UploadIcon style={{ marginRight: '1rem' }} />
                    <input
                      onChange={evt => {
                        handleImageUpload(evt)
                      }}
                      id="actual-btn"
                      type="file"
                      ref={hiddenFileInput}
                      hidden
                    />
                    <Typography variant="body2">Upload Image</Typography>
                  </Box>
                </CustomIconContextMenu>
              ) : (
                <CustomIconContextMenu
                  title=""
                  icon={
                    <StyledImageEditBox>
                      <StyledImageEditIcon fontSize="1.5rem" />
                    </StyledImageEditBox>
                  }
                  menuWidth="30rem"
                  bgColor={theme.colors.bgPrimary}
                  anchorOriginHorizontal="right"
                >
                  <Box display="flex" justifyContent="space-between" onClick={() => hiddenFileInput.current.click()}>
                    <UploadIcon style={{ marginRight: '0.8rem' }} />
                    <input
                      onChange={evt => {
                        handleImageUpload(evt)
                      }}
                      id="actual-btn"
                      type="file"
                      ref={hiddenFileInput}
                      hidden
                    />
                    <Typography variant="body2">Upload Image</Typography>
                  </Box>
                  {user?.image && (
                    <Box display="flex" justifyContent="space-between" onClick={evt => handleRemoveImage(evt)}>
                      <DeleteIcon style={{ marginRight: '1rem', marginLeft: '0.3rem' }} />
                      <Typography variant="body2">Remove Image</Typography>
                    </Box>
                  )}
                </CustomIconContextMenu>
              )}
            </Box>
          </Box>
        </Box>
      </Box>
    </Box>
  )
}

export default observer(AddAvatar2)
